import React from 'react';
import { MSocialGroupProps, MSocialGroupIconInteractive } from './MSocialGroup.types';
import { Wrapper, IconsContainer } from './MSocialGroup.styles';
import { ASubheader } from '../../atoms/ASubheader/index';
import { MIconInteractive } from '../MIconInteractive/index';

export const MSocialGroup: React.FC<MSocialGroupProps> = ({
  orientation,
  aSubheader,
  mIconInteractive,
  onNavigate,
}) => {
  return (
    <Wrapper orientation={orientation} data-testid="web-ui-kit-MSocialGroup">
      {aSubheader && <ASubheader {...aSubheader} />}
      {mIconInteractive && mIconInteractive.length > 0 && (
        <IconsContainer orientation={orientation}>
          {mIconInteractive.map((iconItem: MSocialGroupIconInteractive, index) => (
            <MIconInteractive
              key={`${iconItem.aIcon?.icon ?? 'icon'}-${index}`}
              aIcon={iconItem.aIcon}
              onClick={() => onNavigate(iconItem.ctaLink, iconItem.openInANewTab)}
            />
          ))}
        </IconsContainer>
      )}
    </Wrapper>
  );
};
